import { useState, useRef } from 'react';
import { useTheme } from '../context/ThemeContext';

export function useToast() {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);

  const show = (message, type = 'success') => {
    if (timer.current) clearTimeout(timer.current);
    setToast({ message, type });
    timer.current = setTimeout(() => setToast(null), 3000);
  };

  return { toast, show };
}

export default function Toast({ toast }) {
  const { T } = useTheme();
  if (!toast) return null;

  const borderColor = toast.type === 'success' ? T.success : T.error;
  const textColor   = toast.type === 'success' ? T.success : T.error;

  return (
    <div style={{
      position: 'fixed', bottom: 28, left: '50%', transform: 'translateX(-50%)',
      background: T.bgCardSolid,
      border: `1px solid ${borderColor}`,
      color: textColor,
      borderRadius: 12, padding: '12px 28px',
      fontSize: 14, fontWeight: 500,
      zIndex: 2000, whiteSpace: 'nowrap',
      boxShadow: '0 8px 28px rgba(0,0,0,0.2)',
      transition: 'opacity 0.2s ease',
    }}>
      {toast.message}
    </div>
  );
}
